import { IReportCell } from "./ReportBespokeStore";

interface ITemplateDefinition {
  cells: IReportCell[];
}

export const PORTRAIT_DIMENSIONS = {
  FULL_HEIGHT: 800,
  HALF_HEIGHT: 320,
  HALF_WIDTH: 350,
  FULL_WIDTH: 800,
};

export const LANDSCAPE_DIMENSIONS = {
  FULL_HEIGHT: undefined as any, // keeping original value
  HALF_HEIGHT: 180,
  HALF_WIDTH: 500,
  FULL_WIDTH: 1000,
};
export enum TemplateType {
  FULL_SCREEN = "FULL_SCREEN",
  HALF_SCREEN_VERTICAL = "HALF_SCREEN_VERTICAL",
  HALF_SCREEN_HORIZONTAL = "HALF_SCREEN_HORIZONTAL",
  FOUR_BY_FOUR = "FOUR_BY_FOUR",
  TOP_BOTTOM_SPLIT = "TOP_BOTTOM_SPLIT",
  BOTTOM_TOP_SPLIT = "BOTTOM_TOP_SPLIT",
  LEFT_RIGHT_SPLIT = "LEFT_RIGHT_SPLIT",
  RIGHT_LEFT_SPLIT = "RIGHT_LEFT_SPLIT",
  // Add more templates as needed
}

export enum AlignmentType {
  TOP_LEFT = "TOP_LEFT",
  TOP_RIGHT = "TOP_RIGHT",
  BOTTOM_LEFT = "BOTTOM_LEFT",
  BOTTOM_RIGHT = "BOTTOM_RIGHT",
  CENTER = "CENTER",
  CENTER_LEFT = "CENTER_LEFT",
  CENTER_RIGHT = "CENTER_RIGHT",
  CENTER_TOP = "CENTER_TOP",
  CENTER_BOTTOM = "CENTER_BOTTOM",
}

export const TEMPLATE_DEFINITIONS_PORTRAIT: {
  [key in TemplateType]: ITemplateDefinition;
} = {
  [TemplateType.FULL_SCREEN]: {
    cells: [
      {
        id: "0-0",
        chartWidth: PORTRAIT_DIMENSIONS.FULL_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.FULL_HEIGHT,
        width: 100,
        height: 100,
        alignment: AlignmentType.CENTER_TOP,
      },
    ],
  },
  [TemplateType.HALF_SCREEN_HORIZONTAL]: {
    cells: [
      {
        id: "0-0",
        chartWidth: PORTRAIT_DIMENSIONS.HALF_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.FULL_HEIGHT,
        width: 50,
        height: 100,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "0-1",
        chartWidth: PORTRAIT_DIMENSIONS.HALF_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.FULL_HEIGHT,
        width: 50,
        height: 100,
        alignment: AlignmentType.CENTER_TOP,
      },
    ],
  },
  [TemplateType.HALF_SCREEN_VERTICAL]: {
    cells: [
      {
        id: "0-0",
        chartWidth: PORTRAIT_DIMENSIONS.FULL_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.HALF_HEIGHT,
        width: 100,
        height: 50,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "1-0",
        chartWidth: PORTRAIT_DIMENSIONS.FULL_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.HALF_HEIGHT,
        width: 100,
        height: 50,
        alignment: AlignmentType.CENTER_TOP,
      },
    ],
  },
  [TemplateType.FOUR_BY_FOUR]: {
    cells: [
      {
        id: "0-0",
        chartWidth: PORTRAIT_DIMENSIONS.HALF_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "0-1",
        chartWidth: PORTRAIT_DIMENSIONS.HALF_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "1-0",
        chartWidth: PORTRAIT_DIMENSIONS.HALF_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "1-1",
        chartWidth: PORTRAIT_DIMENSIONS.HALF_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        alignment: AlignmentType.CENTER_TOP,
      },
    ],
  },
  [TemplateType.TOP_BOTTOM_SPLIT]: {
    cells: [
      {
        id: "0-0",
        chartWidth: PORTRAIT_DIMENSIONS.FULL_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.HALF_HEIGHT,
        width: 100,
        height: 50,
        position: "absolute",
        top: 0,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "1-0",
        chartWidth: PORTRAIT_DIMENSIONS.HALF_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        position: "absolute",
        top: "50%",
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "1-1",
        chartWidth: PORTRAIT_DIMENSIONS.HALF_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        position: "absolute",
        left: "50%",
        top: "50%",
        alignment: AlignmentType.CENTER_TOP,
      },
    ],
  },
  [TemplateType.BOTTOM_TOP_SPLIT]: {
    cells: [
      {
        id: "1-0",
        chartWidth: PORTRAIT_DIMENSIONS.FULL_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.HALF_HEIGHT,
        width: 100,
        height: 50,
        position: "absolute",
        top: "50%",
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "0-0",
        chartWidth: PORTRAIT_DIMENSIONS.HALF_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        position: "absolute",
        top: 0,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "0-1",
        chartWidth: PORTRAIT_DIMENSIONS.HALF_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        position: "absolute",
        left: "50%",
        top: 0,
        alignment: AlignmentType.CENTER_TOP,
      },
    ],
  },
  [TemplateType.LEFT_RIGHT_SPLIT]: {
    cells: [
      {
        id: "0-0",
        chartWidth: PORTRAIT_DIMENSIONS.HALF_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.FULL_HEIGHT,
        width: 50,
        height: 100,
        position: "absolute",
        left: 0,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "0-1",
        chartWidth: PORTRAIT_DIMENSIONS.HALF_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        position: "absolute",
        left: "50%",
        top: 0,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "1-1",
        chartWidth: PORTRAIT_DIMENSIONS.HALF_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        position: "absolute",
        left: "50%",
        top: "50%",
        alignment: AlignmentType.CENTER_TOP,
      },
    ],
  },
  [TemplateType.RIGHT_LEFT_SPLIT]: {
    cells: [
      {
        id: "0-1",
        chartWidth: PORTRAIT_DIMENSIONS.HALF_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.FULL_HEIGHT,
        width: 50,
        height: 100,
        position: "absolute",
        left: "50%",
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "0-0",
        chartWidth: PORTRAIT_DIMENSIONS.HALF_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        position: "absolute",
        top: 0,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "1-0",
        chartWidth: PORTRAIT_DIMENSIONS.HALF_WIDTH,
        chartHeight: PORTRAIT_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        position: "absolute",
        top: "50%",
        alignment: AlignmentType.CENTER_TOP,
      },
    ],
  },
};

export const TEMPLATE_DEFINITIONS_LANDSCAPE: {
  [key in TemplateType]: ITemplateDefinition;
} = {
  [TemplateType.FULL_SCREEN]: {
    cells: [
      {
        id: "0-0",
        chartWidth: LANDSCAPE_DIMENSIONS.FULL_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.FULL_HEIGHT,
        width: 100,
        height: 100,
        alignment: AlignmentType.CENTER_TOP,
      },
    ],
  },
  [TemplateType.HALF_SCREEN_HORIZONTAL]: {
    cells: [
      {
        id: "0-0",
        chartWidth: LANDSCAPE_DIMENSIONS.HALF_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.FULL_HEIGHT,
        width: 50,
        height: 100,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "0-1",
        chartWidth: LANDSCAPE_DIMENSIONS.HALF_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.FULL_HEIGHT,
        width: 50,
        height: 100,
        alignment: AlignmentType.CENTER_TOP,
      },
    ],
  },
  [TemplateType.HALF_SCREEN_VERTICAL]: {
    cells: [
      {
        id: "0-0",
        chartWidth: LANDSCAPE_DIMENSIONS.FULL_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.HALF_HEIGHT,
        width: 100,
        height: 50,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "1-0",
        chartWidth: LANDSCAPE_DIMENSIONS.FULL_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.HALF_HEIGHT,
        width: 100,
        height: 50,
        alignment: AlignmentType.CENTER_TOP,
      },
    ],
  },
  [TemplateType.FOUR_BY_FOUR]: {
    cells: [
      {
        id: "0-0",
        chartWidth: LANDSCAPE_DIMENSIONS.HALF_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "0-1",
        chartWidth: LANDSCAPE_DIMENSIONS.HALF_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "1-0",
        chartWidth: LANDSCAPE_DIMENSIONS.HALF_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "1-1",
        chartWidth: LANDSCAPE_DIMENSIONS.HALF_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        alignment: AlignmentType.CENTER_TOP,
      },
    ],
  },
  [TemplateType.TOP_BOTTOM_SPLIT]: {
    cells: [
      {
        id: "0-0",
        chartWidth: LANDSCAPE_DIMENSIONS.FULL_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.HALF_HEIGHT,
        width: 100,
        height: 50,
        position: "absolute",
        top: 0,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "1-0",
        chartWidth: LANDSCAPE_DIMENSIONS.HALF_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        position: "absolute",
        top: "50%",
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "1-1",
        chartWidth: LANDSCAPE_DIMENSIONS.HALF_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        position: "absolute",
        left: "50%",
        top: "50%",
        alignment: AlignmentType.CENTER_TOP,
      },
    ],
  },
  [TemplateType.BOTTOM_TOP_SPLIT]: {
    cells: [
      {
        id: "1-0",
        chartWidth: LANDSCAPE_DIMENSIONS.FULL_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.HALF_HEIGHT,
        width: 100,
        height: 50,
        position: "absolute",
        top: "50%",
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "0-0",
        chartWidth: LANDSCAPE_DIMENSIONS.HALF_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        position: "absolute",
        top: 0,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "0-1",
        chartWidth: LANDSCAPE_DIMENSIONS.HALF_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        position: "absolute",
        left: "50%",
        top: 0,
        alignment: AlignmentType.CENTER_TOP,
      },
    ],
  },
  [TemplateType.LEFT_RIGHT_SPLIT]: {
    cells: [
      {
        id: "0-0",
        chartWidth: LANDSCAPE_DIMENSIONS.HALF_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.FULL_HEIGHT,
        width: 50,
        height: 100,
        position: "absolute",
        left: 0,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "0-1",
        chartWidth: LANDSCAPE_DIMENSIONS.HALF_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        position: "absolute",
        left: "50%",
        top: 0,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "1-1",
        chartWidth: LANDSCAPE_DIMENSIONS.HALF_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        position: "absolute",
        left: "50%",
        top: "50%",
        alignment: AlignmentType.CENTER_TOP,
      },
    ],
  },
  [TemplateType.RIGHT_LEFT_SPLIT]: {
    cells: [
      {
        id: "0-1",
        chartWidth: LANDSCAPE_DIMENSIONS.HALF_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.FULL_HEIGHT,
        width: 50,
        height: 100,
        position: "absolute",
        left: "50%",
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "0-0",
        chartWidth: LANDSCAPE_DIMENSIONS.HALF_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        position: "absolute",
        top: 0,
        alignment: AlignmentType.CENTER_TOP,
      },
      {
        id: "1-0",
        chartWidth: LANDSCAPE_DIMENSIONS.HALF_WIDTH,
        chartHeight: LANDSCAPE_DIMENSIONS.HALF_HEIGHT,
        width: 50,
        height: 50,
        position: "absolute",
        top: "50%",
        alignment: AlignmentType.CENTER_TOP,
      },
    ],
  },
};
